import PalomaBackend from "@astina/paloma-common-ui/src/services/PalomaBackend";
import gtmService from './GtmAnalyticsService';
import events from "@astina/paloma-common-ui/src/services/EventBus";
import products from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
async function fetchTotalCount(query, category) {
    try {
        const res = await products.searchProducts({
            query: query,
            category: category,
            size: 1,
        });
        return res.total || res.totalElements || 0;
    }
    catch (e) {
        console.error('Search count fetch failed', e);
        return 0;
    }
}
export function initAnalytics() {
    window.dataLayer = window.dataLayer || [];
    let previousUrl = document.referrer;
    PalomaBackend.http.interceptors.response.use((response) => {
        const currentUrl = window.location.href;
        const currentTitle = document.title;
        const win = window;
        const isStage = !win._ENV?.version || /stage|snapshot/i.test(win._ENV.version);
        const environmentStr = isStage ? 'stage' : 'prod';
        const currentLang = document.documentElement.lang || 'en';
        gtmService.trackPageLoad(environmentStr, currentLang, currentUrl, currentTitle, previousUrl);
        previousUrl = currentUrl;
        return response;
    }, (error) => {
        return Promise.reject(error);
    });
    events.$on('track.add_to_cart', (eventPayload) => {
        const addedItems = eventPayload.addedItems;
        const currency = eventPayload.currency;
        gtmService.trackAddToCart(addedItems || [], currency);
    });
    events.$on('track.add_to_wishlist', (eventPayload) => {
        const affectedItems = eventPayload.affectedItems || [];
        if (affectedItems.length > 0) {
            gtmService.trackAddToWishlist(affectedItems || [], 'CHF');
        }
        else {
            console.warn('Analytics Warning: No items found for track.add_to_wishlist.');
        }
    });
    events.$on('track.purchase_order', (eventPayload) => {
        const order = eventPayload.order;
        try {
            gtmService.trackPurchase(order);
        }
        catch (e) {
            console.error('Analytics Error:', e);
        }
    });
    events.$on('track.remove_from_cart', (eventPayload) => {
        const removedItems = eventPayload.removedItems;
        const currency = eventPayload.currency;
        try {
            gtmService.trackRemoveFromCart(removedItems || [], currency);
        }
        catch (e) {
            console.error('Analytics Error:', e);
        }
    });
    events.$on('track.click_category', (eventPayload) => {
        const categoryCode = eventPayload.categoryCode;
        const categoryName = eventPayload.categoryName;
        gtmService.trackCategoryClick(categoryCode, categoryName);
    });
    events.$on('track.view_item', (eventPayload) => {
        const product = eventPayload.product;
        gtmService.trackViewItem(product);
    });
    events.$on('track.home_search', async (eventPayload) => {
        const query = eventPayload.query;
        const type = eventPayload.type;
        const count = await fetchTotalCount(query);
        gtmService.trackSearch(type, query, count);
    });
    events.$on('track.home_suggestion', async (eventPayload) => {
        const query = eventPayload.query;
        const type = eventPayload.type;
        const route = eventPayload.route;
        const category = type === 'suggest-category' ? route.params.category : null;
        const count = type === 'suggest-product' ? 1 : await fetchTotalCount(category ? null : query, category);
        gtmService.trackSearch(type, query, count, route);
    });
}
